import React, { useState, useEffect } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    Button,
    MenuItem,
    Stack,
    Paper,
    Table,
    TableBody,
    TableHead,
    TableRow,
    TableCell,
    TableContainer,
    Pagination,
} from '@mui/material';
import { useAppContext } from '../context/AppContext';
import { useParams } from 'react-router-dom';

const initialData = [
    { date: '2023-10-01', reason: 'Load', amount: 100, type: 'Prepaid' },
    { date: '2023-10-02', reason: 'Load', amount: 50, type: 'PASG' },
    { date: '2023-10-03', reason: 'Transfer', amount: -20, type: 'Prepaid' },
    { date: '2023-10-04', reason: 'Transfer', amount: 200, type: 'PASG' },
    { date: '2023-10-05', reason: 'Transfer', amount: 150, type: 'Prepaid' },
    { date: '2023-10-06', reason: 'Load', amount: 100, type: 'Prepaid' },
    { date: '2023-10-07', reason: 'Load', amount: 50, type: 'PASG' },
    { date: '2023-10-08', reason: 'Transfer', amount: -20, type: 'Prepaid' },
    { date: '2023-10-09', reason: 'Transfer', amount: 200, type: 'PASG' },
    { date: '2023-10-10', reason: 'Transfer', amount: 150, type: 'Prepaid' },
];

const itemsPerPage = 5;

const TransactionList = ({ transactions }) => {
    console.log('Transactions:', transactions);
    const [currentPage, setCurrentPage] = useState(1);

    const handlePageChange = (_, page) => {
        setCurrentPage(page);
    };

    const paginatedTransactions = transactions.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom>
                Transaction History
            </Typography>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            {/* <TableCell>Reason</TableCell> */}
                            <TableCell>Amount</TableCell>
                            {/* <TableCell>Type</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedTransactions.map((transaction, index) => (
                            <TableRow key={index}>
                                <TableCell>{transaction.timestamp}</TableCell>
                                {/* <TableCell>{transaction.reason}</TableCell> */}
                                <TableCell>{transaction.amount}</TableCell>
                                {/* <TableCell>{transaction.type}</TableCell> */}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Pagination
                count={Math.ceil(transactions.length / itemsPerPage)}
                page={currentPage}
                onChange={handlePageChange}
                sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}
            />
        </Box>
    );
};

const UserApplication = () => {
    const { id , app} = useParams();
    const [user, setUser] = useState('Nombre');
    const [application, setApplication] = useState(app);
    const [type, setType] = useState('Prepaid');
    const [credit, setCredit] = useState('0');
    const { getBilling } = useAppContext();

    const [credit_purchases, setCreditPurchases] = useState([]);

    const handleTransfer = () => {
        alert(`Transferring credits for User: ${user}, Application: ${application}`);
    };

    const handleLoad = () => {
        alert(`Loading credits for User: ${user}, Application: ${application}`);
    };

    useEffect(() => {

        const fetchData = async () => {
            try {
                
                const data = await getBilling(id, application);
                console.log('Fetched data:', data);
                console.log('credit_purchases: ', data.credit_purchases);
                setCreditPurchases(data.credit_purchases);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    return (
        <>
            <Box sx={{ p: 3, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Card sx={{ width: 400 }}>
                    <CardContent>
                        <Typography variant="h5" gutterBottom>
                            User Application
                        </Typography>
                        <Stack spacing={2}>
                            <TextField
                                label="User"
                                value={user}
                                onChange={(e) => setUser(e.target.value)}
                                fullWidth
                            />
                            <TextField
                                label="Application"
                                value={application}
                                onChange={(e) => setApplication(e.target.value)}
                                fullWidth
                            />
                            <TextField
                                label="Type"
                                select
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                                fullWidth
                            >
                                <MenuItem value="Prepaid">Prepaid</MenuItem>
                                <MenuItem value="PASG">PASG</MenuItem>
                            </TextField>
                            <TextField
                                label="Credit"
                                type="number"
                                value={credit}
                                onChange={(e) => setCredit(e.target.value)}
                                fullWidth
                            />
                            <Button variant="contained" color="primary" onClick={handleLoad}>
                                Load
                            </Button>
                            <Button variant="outlined" color="secondary" onClick={handleTransfer}>
                                Transfer
                            </Button>
                        </Stack>
                    </CardContent>
                </Card>
            </Box>
            <TransactionList transactions={credit_purchases} />
        </>
    );
};

export default UserApplication;